<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row  mt-2">



                    <div class="col-md-2 ">
                        <b-link class="" :to="{ path: '/branch-target-form',query: { type: 'add'} }">
                            <b-button class="btn-info mb-2" > Add Target </b-button>
                        </b-link>
                    </div>

<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.order_id"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_claims()-->
<!--                              }"-->
<!--                                 placeholder="Order ID"></b-input>-->
<!--                    </div>-->
<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.customer_name"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_claims()-->
<!--                              }"-->
<!--                                 placeholder="Name"></b-input>-->
<!--                    </div>-->
<!--                    <div class="col-md-2">-->
<!--                        <b-input v-model="claimfilters.phone_number"-->
<!--                                 @input="()=>{-->
<!--                                 this.claimfilters.page=1;-->
<!--                                 this.get_claims()-->
<!--                              }"-->
<!--                                 placeholder="Mobile"></b-input>-->
<!--                    </div>-->


                    <div class="col-md-2">
                        <v-select
                            v-model="branch_target_filters.branch_id"
                            @input="()=>{
                                 this.branch_target_filters.page=1;
                                 this.get_branch_targets()
                              }"
                            class="text-dark"
                            placeholder="Branch"
                            :options="branches"

                            label="name"
                            :reduce="option => option.id"

                        />
                    </div>
<!--                    <div class="col-md-2">-->
<!--                        <v-select-->
<!--                            v-model="branch_target_filters.status"-->
<!--                            @input="()=>{-->
<!--                                 this.branch_target_filters.page=1;-->
<!--                                 this.get_branch_targets()-->
<!--                              }"-->
<!--                            class="text-dark"-->
<!--                            placeholder="Status"-->
<!--                            :options="['Pending','Approved','Completed']"-->

<!--                        />-->
<!--                    </div>-->





                    <!--                    <b-table id="customers-table"  class="bg-light" :items="filteredCustomers" :fields="fields" striped hover responsive :per-page="perPage" :current-page="currentPage">-->


                    <!--                        <template #cell(actions)="data">-->

                    <!--                            <b-link class="" :to="{ path: '/customerform',query: { type: 'edit', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > Edit </b-button>-->
                    <!--                            </b-link>-->
                    <!--                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > View </b-button>-->
                    <!--                            </b-link>-->
                    <!--&lt;!&ndash;                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">&ndash;&gt;-->
                    <!--&lt;!&ndash;                                <b-button class="btn-info mb-2" > Orders </b-button>&ndash;&gt;-->
                    <!--&lt;!&ndash;                            </b-link>&ndash;&gt;-->

                    <!--                        </template>-->

                    <!--                    </b-table>-->
                    <!--                    <b-pagination-->
                    <!--                        class=""-->
                    <!--                        v-model="currentPage"-->
                    <!--                        :total-rows="customers.length"-->
                    <!--                        :per-page="perPage"-->
                    <!--                        aria-controls="customers-table"-->
                    <!--                    ></b-pagination>-->
                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                        <!--                        <button class="btn-sm btn-info" @click="getinvoices">-->
                        <!--                            <span v-if="showloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
                        <!--                            Refresh-->
                        <!--                        </button>-->
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="branch_targets?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="branch_targets?.to-50>0">{{branch_targets?.to-50}}</span> <span v-else="">0</span>  to {{branch_targets.to}}) out of {{branch_targets.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="branch_targets?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                    <!--                    <div class="col-md-2 text-right">-->
                    <!--                        <button class="btn-sm btn-warning"    @click="clearfilters" >Clear Filters</button>-->
                    <!--                    </div>-->

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-bordered table-striped text-light">
                        <thead class="thead-dark">
                        <tr>

                            <th>Branch</th>

                            <th>Month</th>
                            <th>Min Target</th>
                            <th>Target</th>
                            <th>High Target</th>




                            <th class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody id="customerTableBody">
                        <tr v-for="target in branch_targets.data">


                            <td>{{branches.find((b)=>b.id==target.branch_id).name}}</td>

                            <td>{{formatDate(target.month)}}</td>
                            <td>{{target.min_target}}</td>
                            <td>{{target.target}}</td>
                            <td>{{target.high_target}}</td>


                            <td class="text-center">

<!--                                <b-button @click="approveclaim(claim.id)" v-if="authenticatedUser.permissions.includes('super') && claim.claim_status==='Pending'" :disabled="saving" class="btn-success mb-2 mx-1"> Approve </b-button>-->
                                <b-link class="mx-1" :to="{ path: '/branch-target-form',query: { type: 'edit', 'id': target.id } }">
                                    <b-button class="btn-info mb-2" > Edit </b-button>
                                </b-link>
                                <b-button @click="deletetarget(target.id)" v-if="authenticatedUser.permissions.includes('super')" :disabled="saving" class="btn-danger mb-2"> Delete </b-button>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>



            </div>

        </div>

    </div>

</template>

<script>
//import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import vSelect from "vue-select";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import moment from "moment/moment";
//import vSelect from "vue-select";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import apiService from "@/service/apiService";
import Swal from "sweetalert2";
import axios from "axios";


export default {
    name: "branch targets",

    components:{Loader, Welcomenote, 'v-select': vSelect,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('branch_targets',['branch_target_filters']),
        //  ...mapState('customers', ['customers']), not using this state
        ...mapState('invoice', ['branches']),
        totalPages() {
            const perpage = this.branch_targets.per_page;
            const total=this.branch_targets.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            // RTO_URL:'http://127.0.0.1:8185',
            RTO_URL:'https://righttiles.co.uk',
            OTO_URL:'http://127.0.0.1:8186',
            roles: [],
            user: {},
            // perPage:100,
            // currentPage: 1,
            branch_targets:[],
            showloader:false,


            // cashier_id:'',
            // order_status:'',
            // branch_id:'',
            // searchcustname:'',
            // searchcustphone:'',
            // searchcustemail:'',
            // custtype:'',
            // credit:true,

            // fields: [
            //
            //     { key: 'lastName', label: 'Name' },
            //     { key: 'mobile', label: 'Mobile' },
            //     { key: 'customerType', label: 'Customer Type' },
            //     { key: 'email', label: 'Email' },
            //     { key: 'walletBalance', label: 'Balance' },
            //     'actions'
            //
            // ],

        };
    },
    async created() {
        //  await this.getUsers();
        //   await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()

        const promises = [

            this.reloadcb(),
            this.get_branch_targets(),

        ];
        await Promise.all(promises);

    },
    async mounted() {
        Fancybox.bind("[data-fancybox]", {});

    },
    updated() {

        Fancybox.bind("[data-fancybox]", {});
    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),

        async approveclaim(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to approve this claim?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.post(`${URL.BASEURL}/api/approve-claim/${id}`);

                    if (res) {

                        // this.claims.data= this.claims.data.map((c)=>{
                        //    if(c.id===res.id) {
                        //        return res
                        //    } else {
                        //        return c
                        //    }
                        // })

                        Swal.fire('success', 'Claim Approved', 'success');
                        await  this.get_branch_targets()

                    } else {
                        Swal.fire('info', 'Claim Cant be Approved', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to Approve Claim.', 'info');
                }
                this.saving=false
            }

        },
        async deletetarget(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this target?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-target/${id}`);

                    if (res) {
                        this.branch_targets.data= this.branch_targets.data.filter((c)=>c.id!==id)

                        Swal.fire('success', 'Target  Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Target Cant be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete Target.', 'info');
                }
                this.saving=false
            }

        },




        formatDate(date){
            let date1 = new Date(date)
            let date2 = moment(date1).format('MMMM');

            return date2;
        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },


        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },

        async get_paged_data(button){
            let current_page= this.branch_targets.current_page
            this.branch_target_filters.page=current_page



            if(button=='next'){

                this.branch_target_filters.page=current_page+1

                await   this.get_branch_targets()

            }
            if(button=='prev'){
                this.branch_target_filters.page=current_page-1

                await  this.get_branch_targets()


            }

        },
        async  get_branch_targets() {
            let user = localStorage.getItem('user');
            user=  JSON.parse(user)
            const apiToken = localStorage.getItem('token');
            let url=`${URL.BASEURL}/api/branch-targets`
            let filters ={

                status:this.branch_target_filters.status,


                page:this.branch_target_filters.page,


            };
            if(user.permissions.includes('super')){

                filters.branch_id=this.branch_target_filters.branch_id;

            } else {
                filters.branch_id=user.branch.id;
            }
            this.showloader=true
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                this.branch_targets=res
                // console.log('customers:', res);
            } catch (error) {
                console.error('Error:', error);
            }
            this.showloader=false
        }

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}



</style>
